import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { capitalizeFirstLetter } from '@utils/stringUtils';
import analytics from '@utils/analytics';
import { appPostStructuredMessage } from '@utils/appUtils';
import cookie from 'react-cookies';
const targetEndpoints = {
    account: 1,
    checkout: 2,
    preferences: 3,
    cart: 4,
    wishlist: 5,
};
const SocialButton = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    let redirectParams = {};
    let anchorParams;
    if (props.reloadUrl && ((_a = props.reloadUrl) === null || _a === void 0 ? void 0 : _a.indexOf('?')) > -1) {
        let url = props.reloadUrl.split('?')[1];
        let pairs = url.split('&');
        pairs.forEach(function (pair) {
            pair = pair.split('=');
            redirectParams[pair[0]] = decodeURIComponent(pair[1] || '');
        });
    }
    if (props.reloadUrl && ((_b = props.reloadUrl) === null || _b === void 0 ? void 0 : _b.indexOf('#')) > -1) {
        anchorParams = props.reloadUrl.split('#')[1];
    }
    const socialLink = (provider) => {
        var _a;
        return `${window.sociallogin}?oauthProvider=${capitalizeFirstLetter(provider)}${props.reloadTarget ? '&oauthLoginTargetEndPoint=' + targetEndpoints[props.reloadTarget] : ''}${props.reloadUrl ? '&targetReload=' + ((_a = props.reloadUrl) === null || _a === void 0 ? void 0 : _a.split(/[?#]/)[0]) : ''}${Object.keys(redirectParams).length ? '&redirectParams=' + JSON.stringify(redirectParams) : ''}${anchorParams ? '&anchorParams=' + anchorParams : ''}`;
    };
    return (React.createElement("a", { onClick: (e) => {
            // send analytics
            props.setIsLoading && props.setIsLoading(true);
            props.from && analytics.expressCheckoutSocialLoginRegister(props.from, props.social.toLowerCase());
            props.analyticsKey === 'earlyAccess' && analytics[props.analyticsKey]('pop-up', `${props.social.toLowerCase()}-login`);
            props.social &&
                props.analyticsKey === 'modal' &&
                analytics.socialLoginGeneric({ event: 'popup', eventCategory: 'popup', eventAction: `${props.social.toLowerCase()}-login`, eventLabel: 'open' });
            props.social && props.analyticsKey === 'menu'
                ? analytics.socialLoginGeneric({ eventAction: `${props.social.toLowerCase()}-login`, eventLabel: 'open' })
                : analytics.socialLoginGeneric({ eventAction: `${props.social.toLowerCase()}-login`, eventLabel: 'login' });
            // Sent to BE information to redirect the user to the wishlist if he comes from it
            if (props.from === 'wishlist') {
                cookie.save('fromWishlist', 'true', { path: '/', maxAge: 600 });
            }
            else {
                cookie.remove('fromWishlist');
            }
            // send message & deactivated operation 'sign in with google' for app
            if (window.appmode) {
                props.social == 'google' && window.appmode && appPostStructuredMessage('checkout_google_signin', {});
                e.preventDefault();
            }
        }, className: classNames('button social-button', `button--${props.secondary ? 'secondary' : 'link'}`), href: socialLink(props.social) },
        React.createElement("div", { className: `icon--social-${props.social}` }),
        t(props.register ? `signup.${props.social}` : `signin.${props.social}`)));
};
export default SocialButton;
